import { SEARCH_RESULTS_PAGING_LABEL } from "../../../i18n/keyConstants";

const NumberOfSearchResults = ({ pageSize, tableSize, currentPage, t }) => {
    const offset = (currentPage - 1) * pageSize + 1;

    const start = tableSize > 0 ? offset : 0;
    const end = pageSize * currentPage > tableSize ? tableSize : pageSize * currentPage;

    return `${start}-${end} ${t(SEARCH_RESULTS_PAGING_LABEL, {ns: 'shared'})} ${tableSize}`;
};

export default NumberOfSearchResults;
